export default "/images/xero.svg?f426ba5d39ad1731bbc2718079713577";